import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  container: {
    [theme.breakpoints.down('sm')]: {
      // backgroundColor: '#f5f5f5',
      // minWidth: '100% !important',
    },
  },
  titleBackground: {
    backgroundImage: 'url(${bgImage})',
    height: '70px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '2rem'
  },
  cardGridContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, 1fr)',
    gap: '1rem',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      position: 'relative',
      overflowX: 'auto',
      scrollSnapType: 'x mandatory',
      padding: '0.5rem 2rem',
      margin: '1rem 0 2rem',
      scrollbarWidth: 'none',
      msOverflowStyle: 'none',
      '&::-webkit-scrollbar': {
        display: 'none',
      }
    }
  },
  cardCarouselContainer: {
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      padding: '1rem 0 2rem',
    }
  },
  cardItemContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '0.5rem',
    marginBottom: '1rem',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      flexShrink: 0,
      scrollSnapAlign: 'center',
      transition: 'all 0.4s ease',
      padding: '1rem 0.5rem',
      transform: 'scale(0.85)',
      opacity: 0.7,
    }
  },
  activeCard: {
    [theme.breakpoints.down('sm')]: {
      opacity: '1',
      transform: 'scale(1)',
      zIndex: 2,
    }
  },
  adjacentCard: {
    [theme.breakpoints.down('sm')]: {
      opacity: '0.8',
      transform: 'scale(0.9)',
      zIndex: 1,
    }
  },
  cardImageContainer: {
    width: '253px',
    height: '162px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '0.5rem',
    perspective: '1000px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: 'auto',
      aspectRatio: '253/162',
      maxWidth: '253px'
    }
  },
  cardImage: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    transition: 'transform 0.5s ease',
    backfaceVisibility: 'hidden',
    [theme.breakpoints.down('sm')]: {
      maxHeight: '162px'
    }
  },
  activeCardImage: {
    transform: 'rotateY(0deg)',
  },
  inactiveCardImage: {
    transform: 'rotateY(15deg)',
  },
  cardNavigationButton: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 10,
    backgroundColor: 'rgba(255,255,255,0.8)',
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    boxShadow: '0 2px 5px rgba(0,0,0,0.15)',
    border: 'none',
    outline: 'none',
    '&:hover': {
      backgroundColor: 'rgba(255,255,255,1)',
    },
    [theme.breakpoints.up('md')]: {
      display: 'none'
    }
  },
  prevButton: {
    left: 0,
  },
  nextButton: {
    right: 0,
  },
  cardIndicators: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '1.5rem',
    [theme.breakpoints.up('md')]: {
      display: 'none'
    }
  },
  cardIndicator: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: '#ccc',
    cursor: 'pointer',
    transition: 'all 0.3s ease'
  },
  activeIndicator: {
    backgroundColor: '#005FAA',
    transform: 'scale(1.5)',
    width: '10px',
    height: '10px'
  },
  mobileComparisonContainer: {
    padding: '1rem',
    marginTop: '1rem',
    border: '1px solid #eaeaea',
    borderRadius: '8px',
    backgroundColor: '#fff',
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
  },
  cardTitle: {
    color: '#275DA6',
    fontWeight: 'bold',
    marginBottom: '1rem',
    fontSize: '18px',
    textAlign: 'center'
  },
  comparisonSection: {
    marginBottom: '1.5rem'
  },
  sectionTitle: {
    color: '#275DA6',
    fontWeight: 'bold',
    fontSize: '16px',
    marginBottom: '0.5rem',
    borderBottom: '1px solid #eaeaea',
    paddingBottom: '0.5rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer'
  },
  sectionIcon: {
    transition: 'transform 0.3s ease'
  },
  rotatedIcon: {
    transform: 'rotate(-180deg)'
  },
  comparisonRow: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0.75rem 0',
    borderBottom: '1px solid #f5f5f5',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
    }
  },
  featureTitle: {
    color: '#868686',
    fontSize: '14px',
    fontWeight: '500',
    marginBottom: '0.5rem',
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      paddingRight: '1rem',
      flex: '0 0 45%',
      marginBottom: 0
    }
  },
  featureValue: {
    color: '#333',
    fontSize: '14px',
    width: '100%',
    wordBreak: 'break-word',
    [theme.breakpoints.up('sm')]: {
      flex: '0 0 55%',
      textAlign: 'right',
    }
  },
  featureValuePositive: {
    color: '#0A8754',
    fontWeight: '500',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.up('sm')]: {
      justifyContent: 'flex-end'
    }
  },
  featureValueNegative: {
    color: '#D32F2F',
    fontWeight: '500',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.up('sm')]: {
      justifyContent: 'flex-end'
    }
  },
  tabsContainer: {
    margin: '0 -1rem 1rem',
    borderBottom: '1px solid #eaeaea'
  },
  sectionTab: {
    flex: 1,
    padding: '0.75rem 0',
    fontSize: '14px',
    textAlign: 'center',
    color: '#868686',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
  },
  activeTab: {
    color: '#275DA6',
    fontWeight: 'bold',
    borderBottom: '3px solid #275DA6'
  },
  collapsibleSection: {
    maxHeight: '0',
    overflow: 'hidden',
    transition: 'max-height 0.3s ease-in-out'
  },
  expandedSection: {
    maxHeight: '2000px' // Large enough to fit content
  },
  bulletItem: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: '0.5rem',
    '&:last-child': {
      marginBottom: 0
    }
  },
  bulletPoint: {
    color: '#275DA6',
    marginRight: '10px',
    fontSize: '18px',
    lineHeight: '18px'
  },
  highlightedFeature: {
    backgroundColor: 'rgba(39, 93, 166, 0.08)',
    padding: '0.75rem',
    borderRadius: '4px',
    marginBottom: '0.75rem'
  },
  highlightedFeatureContent: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
    }
  },
  featureIconContainer: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '0.5rem'
  },
  checkIcon: {
    color: '#0A8754',
    marginRight: '6px'
  },
  selectCardButton: {
    background: '#005FAA',
    color: '#fff',
    fontSize: '12px',
    fontWeight: '600',
    borderRadius: '2rem',
    padding: '0.5rem 3rem',
    '&:hover': {
      background: '#004c87'
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      maxWidth: 253
    }
  },
  goBackButton: {
    color: '#2F80ED',
    border: '1px solid #2F80ED',
    borderRadius: '1.5rem',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      maxWidth: 253
    }
  },
  goBackButtonContainer: {
    textAlign: 'center',
    marginTop: '2rem',
    marginBottom: '2rem'
  },
  comparisonContainer: {
    overflowX: 'auto',
    margin: '0 -1rem',
    padding: '0 1rem'
  },
}));
